import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { HttpService } from '@web-di-ld/apps/http';
import { UiLoadingService } from 'libs/apps/http/src/lib/ui-loading.service';
import { filter, map, share, shareReplay, switchMap } from 'rxjs/operators';
import { pathUrl } from './configs';
import { LOAN_PRODUCT_TYPE } from './core/constant/base.enum';
import { JsInterfaceService } from './core/services';
import { DialogErrorHandlerService } from './shared/error-handler/dialog-error-handler.service';

@Component({
  selector: 'web-di-ld-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(document:click)': 'handleClick($event)',
  },
})
export class AppComponent {
  navigateEnd$ = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd)
  );
  urlChange$ = this.navigateEnd$.pipe(map((e) => e.urlAfterRedirects));
  titleHeader$ = this.urlChange$.pipe(
    map((path) => this.titleHeader(path)),
    shareReplay(1)
  );
  productType$ = this.httpService.productType$;
  applicationRef$ = this.httpService.applicationRef$;

  constructor(
    private location: Location,
    private router: Router,
    public uiLoadingService: UiLoadingService, // private route: ActivatedRoute, // private cookieService: CookieService
    private httpService: HttpService,
    private jsInterfaceService: JsInterfaceService
  ) {}
  handleClick($event: any) {
    // console.log($event)
  }
  titleHeader(path = this.location.path()) {
    switch (path) {
      case pathUrl.loanApply.apply:
        return 'titleHeader.applyLoan';
      case pathUrl.loanApply.productDetail:
        return 'titleHeader.productDetail';
      case pathUrl.loanApply.calculation:
        return 'titleHeader.calculation';
      case pathUrl.personalInformation:
        return 'titleHeader.personalInformation';
      case pathUrl.additionalInformation:
        return 'titleHeader.additionalInformation';
      case pathUrl.editInformation:
        return 'titleHeader.editInformation';
      case pathUrl.confirmingDetails:
        return 'titleHeader.confirmingDetails';
      case pathUrl.marketingConsent:
        return 'titleHeader.consent';
      case pathUrl.ncbConsent:
        return 'titleHeader.consent';
      case pathUrl.confirmSummary:
        return 'titleHeader.confirmSummary';
      default:
        return '';
    }
  }

  async ngOnInit() {
    const productType = await this.productType$.toPromise();
    const applilcationRef = await this.applicationRef$.toPromise();
    if (
      productType === LOAN_PRODUCT_TYPE.SMARTMONEY &&
      applilcationRef === undefined
    ) {
      this.titleHeader(pathUrl.loanApply.apply);
      this.jsInterfaceService.enterFullScreen(pathUrl.loanApply.apply);
      this.router.navigateByUrl(pathUrl.loanApply.apply);
    }
  }
}
